import React, { useEffect, useState } from 'react'
import { Alert, Button, Modal, Spinner } from 'react-bootstrap'
import apinode from '../../services/apinode'

export function CompetitorsModal({ show, onClose, anuncio, contaSelecionada }) {
  const [products, setProducts] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (show && anuncio) handleSearchConcorrentes()
    if (!show) { setProducts([]); setError('') }
  }, [show, anuncio])

  const handleSearchConcorrentes = async () => {
    if (!anuncio?.TITLE) return
    setLoading(true)
    setError('')
    try {
      const res = await apinode.get(
        `/anuncios/concorrentes/search/${localStorage.idconta}`,
        { params: { q: anuncio.TITLE, limit: 48 } },
      )
      setProducts(res.data.results || [])
      if (!res.data.results?.length) setError('Nenhum concorrente encontrado')
    } catch {
      setError('Erro ao buscar concorrentes')
    } finally {
      setLoading(false)
    }
  }

  const getPriceComparison = (competitorPrice) => {
    if (!anuncio?.PRICE || !competitorPrice) return { diff: 0, percent: 0, status: 'equal' }
    const diff = anuncio.PRICE - competitorPrice
    const percent = ((diff / anuncio.PRICE) * 100).toFixed(1)
    if (diff > 0) return { diff, percent, status: 'higher' }
    if (diff < 0) return { diff: Math.abs(diff), percent: Math.abs(percent), status: 'lower' }
    return { diff: 0, percent: 0, status: 'equal' }
  }

  const fmt = (v) =>
    v?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) || '—'

  const badge = (bg, color, text) => (
    <span style={{
      background: bg, color, padding: '2px 8px', borderRadius: 6,
      fontSize: 10, fontWeight: 600, display: 'inline-block',
    }}>
      {text}
    </span>
  )

  // Resumo de preços
  const avgPrice = products.length > 0
    ? products.reduce((s, p) => s + (p.price || 0), 0) / products.length
    : 0
  const minPrice = products.length > 0 ? Math.min(...products.map(p => p.price || Infinity)) : 0
  const maxPrice = products.length > 0 ? Math.max(...products.map(p => p.price || 0)) : 0

  return (
    <Modal show={show} onHide={onClose} size="lg" centered scrollable>
      <Modal.Header closeButton style={{ borderBottom: '1px solid #e5e7eb' }}>
        <div>
          <Modal.Title style={{ fontSize: 18, fontWeight: 600 }}>
            Análise de Concorrentes
          </Modal.Title>
          {anuncio && (
            <small style={{ color: '#6b7280', display: 'block', marginTop: 4 }}>
              {anuncio.TITLE?.substring(0, 80)}
              {anuncio.TITLE?.length > 80 ? '...' : ''}
            </small>
          )}
        </div>
      </Modal.Header>

      <Modal.Body>
        {/* SEU ANÚNCIO */}
        {anuncio && (
          <div style={{
            background: '#f9fafb', border: '1px solid #e5e7eb',
            borderRadius: 10, padding: 16, marginBottom: 20,
          }}>
            <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 10, fontWeight: 500 }}>
              Seu Anúncio
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12 }}>
              <div>
                <div style={{ fontSize: 12, color: '#9ca3af', marginBottom: 4 }}>Preço</div>
                <div style={{ fontSize: 16, fontWeight: 600, color: '#047857' }}>{fmt(anuncio.PRICE)}</div>
              </div>
              <div>
                <div style={{ fontSize: 12, color: '#9ca3af', marginBottom: 4 }}>Estoque</div>
                <div style={{ fontSize: 16, fontWeight: 600 }}>{anuncio.AVAILABLE_QUANTITY ?? '—'} un.</div>
              </div>
              <div>
                <div style={{ fontSize: 12, color: '#9ca3af', marginBottom: 4 }}>Vendidos</div>
                <div style={{ fontSize: 16, fontWeight: 600 }}>{anuncio.SOLD_QUANTITY ?? 0}</div>
              </div>
              <div>
                <div style={{ fontSize: 12, color: '#9ca3af', marginBottom: 4 }}>MLB</div>
                <a href={anuncio.PERMALINK} target="_blank" rel="noopener noreferrer"
                  style={{ fontSize: 14, fontWeight: 600, color: '#4f46e5', textDecoration: 'none' }}>
                  {anuncio.CODIGOMK}
                </a>
              </div>
            </div>
          </div>
        )}

        {/* LOADING */}
        {loading && (
          <div style={{ textAlign: 'center', padding: 40 }}>
            <Spinner animation="border" style={{ color: '#4f46e5' }} />
            <div style={{ color: '#6b7280', marginTop: 12, fontSize: 14 }}>Buscando concorrentes...</div>
          </div>
        )}

        {/* ERRO */}
        {error && !loading && <Alert variant="warning" className="mb-0">{error}</Alert>}

        {/* RESUMO DE PREÇOS */}
        {!loading && products.length > 0 && (
          <>
            <div style={{
              display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 12, marginBottom: 16,
            }}>
              <div style={{ background: '#f0fdf4', borderRadius: 8, padding: '10px 12px', textAlign: 'center' }}>
                <div style={{ fontSize: 11, color: '#047857', marginBottom: 4 }}>Menor preço</div>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#047857' }}>{fmt(minPrice)}</div>
              </div>
              <div style={{ background: '#f8fafc', borderRadius: 8, padding: '10px 12px', textAlign: 'center' }}>
                <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4 }}>Preço médio</div>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#1f2937' }}>{fmt(avgPrice)}</div>
              </div>
              <div style={{ background: '#fef2f2', borderRadius: 8, padding: '10px 12px', textAlign: 'center' }}>
                <div style={{ fontSize: 11, color: '#b91c1c', marginBottom: 4 }}>Maior preço</div>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#b91c1c' }}>{fmt(maxPrice)}</div>
              </div>
              <div style={{ background: '#eff6ff', borderRadius: 8, padding: '10px 12px', textAlign: 'center' }}>
                <div style={{ fontSize: 11, color: '#1d4ed8', marginBottom: 4 }}>Seu preço</div>
                <div style={{ fontSize: 15, fontWeight: 700, color: '#1d4ed8' }}>{fmt(anuncio?.PRICE)}</div>
              </div>
            </div>

            <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 12, fontWeight: 500 }}>
              {products.length} concorrente{products.length > 1 ? 's' : ''} encontrado{products.length > 1 ? 's' : ''}
            </div>

            {/* LISTA */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {products.map((product) => {
                const cmp = getPriceComparison(product.price)
                return (
                  <div key={product.id} style={{
                    border: '1px solid #e5e7eb', borderRadius: 10, padding: 12,
                    display: 'grid', gridTemplateColumns: '70px 1fr 150px 80px',
                    gap: 12, alignItems: 'center',
                  }}>
                    {/* Imagem */}
                    <img src={product.thumbnail} alt=""
                      style={{ width: 70, height: 70, objectFit: 'cover', borderRadius: 6, background: '#f3f4f6' }}
                      onError={(e) => { e.target.src = 'https://via.placeholder.com/70' }}
                    />

                    {/* Info */}
                    <div>
                      <p style={{
                        margin: '0 0 6px', fontSize: 13, fontWeight: 500, color: '#1f2937',
                        display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden',
                      }}>
                        {product.title}
                      </p>
                      <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>
                        <strong>{product.seller?.nickname || 'Vendedor'}</strong>
                      </div>
                      <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                        {product.free_shipping && badge('#ecfdf5', '#047857', 'Frete grátis')}
                        {product.is_full && badge('#eff6ff', '#1d4ed8', 'FULL')}
                        {product.discount && badge('#fffbeb', '#b45309', product.discount)}
                        {product.rating && badge('#f3f4f6', '#1f2937', `⭐ ${product.rating}`)}
                        {product.reviews > 0 && badge('#f3f4f6', '#6b7280', `${product.reviews} aval.`)}
                      </div>
                    </div>

                    {/* Preço */}
                    <div style={{ textAlign: 'right' }}>
                      <div style={{ fontSize: 15, fontWeight: 600, color: '#1f2937', marginBottom: 2 }}>
                        {fmt(product.price)}
                      </div>
                      {product.original_price && (
                        <div style={{ fontSize: 11, color: '#9ca3af', textDecoration: 'line-through', marginBottom: 2 }}>
                          {fmt(product.original_price)}
                        </div>
                      )}
                      {cmp.status !== 'equal' && (
                        <div style={{
                          fontSize: 10, fontWeight: 600,
                          color: cmp.status === 'higher' ? '#047857' : '#dc2626',
                          background: cmp.status === 'higher' ? '#ecfdf5' : '#fef2f2',
                          padding: '2px 6px', borderRadius: 4, display: 'inline-block',
                        }}>
                          {cmp.status === 'higher' ? '▲ Você mais caro' : '▼ Você mais barato'} {cmp.percent}%
                        </div>
                      )}
                    </div>

                    {/* Link */}
                    <a href={product.permalink} target="_blank" rel="noopener noreferrer"
                      style={{
                        padding: '6px 10px', background: '#4f46e5', color: 'white',
                        borderRadius: 6, textDecoration: 'none', fontSize: 11, fontWeight: 500, textAlign: 'center',
                      }}>
                      Ver
                    </a>
                  </div>
                )
              })}
            </div>
          </>
        )}
      </Modal.Body>

      <Modal.Footer style={{ borderTop: '1px solid #e5e7eb' }}>
        <Button variant="outline-secondary" onClick={onClose}>Fechar</Button>
      </Modal.Footer>
    </Modal>
  )
}